<template>
	<div id="users" class="page">
		<datatable
			model="users"
			modal="User"
		>
		</datatable>
		<router-view />
	</div>
</template>

<script>
import { mapMutations } from 'vuex'
import Datatable from '../components/Elements/Datatable'

export default {
  name: 'Users',
  data () {
    return {
      //
    }
  },
  components: {
    Datatable
  },
  computed: {
    //
  },
  methods: {
    ...mapMutations([
      'setPageTitle'
    ])
  },
  created () {
    this.setPageTitle('Users')
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Users.vue